@file:OptIn(InternalResourceApi::class)

package boardgametimeapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/boardgametimeapp.composeapp.generated.resources/"

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.img_games: DrawableResource by lazy {
      DrawableResource("drawable:img_games", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_games.png", -1, -1),
      ))
    }

internal val Res.drawable.img_matches: DrawableResource by lazy {
      DrawableResource("drawable:img_matches", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_matches.png", -1, -1),
      ))
    }

internal val Res.drawable.img_players: DrawableResource by lazy {
      DrawableResource("drawable:img_players", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_players.png", -1, -1),
      ))
    }

internal val Res.drawable.img_start_match: DrawableResource by lazy {
      DrawableResource("drawable:img_start_match", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_start_match.png", -1, -1),
      ))
    }

internal val Res.drawable.texture_paper: DrawableResource by lazy {
      DrawableResource("drawable:texture_paper", setOf(
        ResourceItem(setOf(), "${MD}drawable/texture_paper.xml", -1, -1),
      ))
    }

internal val Res.drawable.texture_shadow: DrawableResource by lazy {
      DrawableResource("drawable:texture_shadow", setOf(
        ResourceItem(setOf(), "${MD}drawable/texture_shadow.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("img_games", Res.drawable.img_games)
  map.put("img_matches", Res.drawable.img_matches)
  map.put("img_players", Res.drawable.img_players)
  map.put("img_start_match", Res.drawable.img_start_match)
  map.put("texture_paper", Res.drawable.texture_paper)
  map.put("texture_shadow", Res.drawable.texture_shadow)
}
